<button
  [attr.mat-flat-button]="variant() === 'filled' ? '' : null"
  [attr.mat-stroked-button]="variant() === 'outlined' ? '' : null"
  [attr.mat-button]="variant() === 'text' ? '' : null"
  color="primary"
  [disabled]="disabled()"
  (click)="handleClick($event)"
  class="button font-medium uppercase {{ buttonClasses() || '' }}"
  [ngClass]="{
    'primary-main': color() === 'primary-main',
    'primary-dark': color() === 'primary-dark',
    'primary-light': color() === 'primary-light',
    secondary: color() === 'secondary',
    danger: color() === 'danger',
    small: size() === 'small',
    medium: size() === 'medium',
    large: size() === 'large',
    filled: variant() === 'filled',
    outlined: variant() === 'outlined',
    text: variant() === 'text',
    disabled: disabled(),
  }"
>
  @if (isLoading()) {
    <mat-spinner
      diameter="20"
      [ngClass]="{
        'spinner-white': variant() === 'filled',
        'spinner-primary':
          variant() === 'outlined' && color() === 'primary-main',
        'spinner-secondary':
          variant() === 'outlined' && color() === 'secondary',
        'spinner-danger': variant() === 'outlined' && color() === 'danger',
      }"
    >
    </mat-spinner>
  } @else {
    <ng-content></ng-content>
  }
</button>
